import { useEffect, useState } from "react";
import { Layout } from "../components/layout.tsx";
import { useAuth } from "../context/auth.tsx";
import { type EventRecord, listEvents } from "../api/events.ts";

const PRIORITY_COLORS: Record<string, string> = {
  CRITICAL: "text-red-400 bg-red-900/30",
  HIGH: "text-orange-400 bg-orange-900/30",
  NORMAL: "text-blue-400 bg-blue-900/30",
  LOW: "text-gray-400 bg-gray-800",
  BACKGROUND: "text-gray-500 bg-gray-800",
};

export function EventsPage() {
  const { token } = useAuth();
  const [events, setEvents] = useState<EventRecord[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (token == null) return;
    setLoading(true);
    listEvents(token, { limit: 50 })
      .then((res) => setEvents(res))
      .catch((err: unknown) =>
        setError(err instanceof Error ? err.message : "Failed to load events"),
      )
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <Layout>
      <div className="space-y-6">
        <h1 className="text-2xl font-bold text-white">Event Log</h1>

        {loading && <p className="text-gray-400">Loading...</p>}
        {error != null && <p className="text-red-400">{error}</p>}

        {!loading && events.length === 0 && <p className="text-gray-500">No events yet.</p>}

        <div className="space-y-2">
          {events.map((ev) => (
            <div
              key={ev.id}
              className="space-y-2 rounded-lg border border-gray-800 bg-gray-900 p-4"
            >
              <div className="flex items-center justify-between gap-4">
                <span className="font-mono text-sm text-white">{ev.eventName}</span>
                <span
                  className={`rounded px-2 py-0.5 text-xs font-medium ${PRIORITY_COLORS[ev.priority] ?? "bg-gray-800 text-gray-400"}`}
                >
                  {ev.priority}
                </span>
              </div>
              <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-gray-500">
                <span>source: {ev.sourceAgent}</span>
                {ev.correlationId && <span>correlation: {ev.correlationId.slice(0, 8)}…</span>}
                <span>{new Date(ev.createdAt).toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
